import type { SourcePhoto } from '../api'
import type { FigureAttrs } from './figure'

/** A source photograph as an inline figure; the caption starts as the photo's own. */
export function photoFigure(p: SourcePhoto): FigureAttrs {
  const caption = p.caption ?? ''
  return { assetId: p.id, src: p.url, alt: caption, caption, width: p.width, height: p.height }
}

/** The source text as paragraphs (split on blank lines). */
export function sourceParagraphs(text: string | null): string[] {
  return (text ?? '').split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean)
}

/** How a made-from article source shows: a link only for admins (the archive is admin-only). */
export function articleSourceDisplay(isAdmin: boolean, title: string): { link: boolean; text: string } {
  return isAdmin ? { link: true, text: title } : { link: false, text: `${title} (member article)` }
}
